import { createTheme } from '@mui/material';

const demoAppTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#092e46',
    },
    secondary: {
      main: '#008d96',
    },
  },
  typography: {
    fontFamily: '"Mulish", sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 500,
    },
    button: {
      fontFamily: '"Space Grotesk", sans-serif',
      fontWeight: 500,
    },
  },
});

export default demoAppTheme;
